import { render } from "./AddShooter.vue?vue&type=template&id=569996cd"
import script from "./AddShooter.vue?vue&type=script&lang=js"
export * from "./AddShooter.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__